(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itv-scrolling-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  /**
   * IIFE to encapsulate the scrolling announcement bar logic, preventing global scope pollution.
   */
  const initScrollingBar = (container) => {
    if (!container) return;

    const sectionId = container.dataset.sectionId;
    const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
    const bar = container.querySelector(`#scrolling-bar-${sectionId}`);
    const scroller = bar ? bar.querySelector('.scrolling-announcement-bar__scroller') : null;
    const errorEl = container.querySelector('.scrolling-announcement-bar__error');

    const activationKeyUrl = container.dataset.activationKeyUrl;
    const activationKeyInput = container.dataset.activationKeyInput;
    const enableScrolling = container.dataset.enableScrolling === 'true';

    // 1. Activation Key Check
    fetch(activationKeyUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(text => {
        const liveKey = text.trim();
        if (liveKey === activationKeyInput) {
          // Key is valid, show the section and initialize logic
          sectionElement.style.display = 'block';
          initializeScroller();
        } else {
          // Key is invalid, show error message only in theme editor
          if (window.Shopify && Shopify.designMode) {
            sectionElement.style.display = 'block';
            if(bar) bar.style.display = 'none';
            if(errorEl) errorEl.style.display = 'flex';
          }
          console.warn('Scrolling Announcement Bar: Activation key is invalid.');
        }
      })
      .catch(error => {
        console.error('Scrolling Announcement Bar: Error fetching activation key:', error);
        if (window.Shopify && Shopify.designMode) {
          sectionElement.style.display = 'block';
          if(bar) bar.style.display = 'none';
          if(errorEl) {
             errorEl.style.display = 'flex';
             errorEl.textContent = 'Could not fetch activation key. Check URL and network connection.';
          }
        }
      });

    // 2. Scroller Initialization Logic
    const initializeScroller = () => {
      if (!bar || !scroller) {
        return;
      }

      // Clear any previous clones and reset state
      const originalItems = scroller.querySelectorAll('.scrolling-announcement-bar__item-wrapper:not(.is-clone)');
      scroller.innerHTML = '';
      originalItems.forEach(item => scroller.appendChild(item));
      bar.classList.remove('is-scrolling', 'is-static');
      
      // If scrolling is disabled, or there are no items, make it static and centered.
      if (!enableScrolling || originalItems.length === 0) {
        bar.classList.add('is-static');
        return;
      }

      // Ensure all content is rendered before measuring
      requestAnimationFrame(() => {
        const barWidth = bar.offsetWidth;
        const itemsToClone = Array.from(scroller.children);
        
        // This loop ensures the content is wide enough for the seamless animation.
        // Using a higher multiplier (e.g., 4) provides more buffer and ensures a smooth loop
        // even with calculation variances, creating a more robust infinite effect.
        while (scroller.offsetWidth < barWidth * 4) {
          itemsToClone.forEach(item => {
            const clone = item.cloneNode(true);
            clone.classList.add('is-clone'); // Mark clones for easy removal later
            scroller.appendChild(clone);
          });
        }

        // Activate animation
        bar.classList.add('is-scrolling');
      });
    };
  };

  /**
   * Initializes all announcement bars on the page.
   * This runs on initial page load.
   */
  const setupAllBars = () => {
    document.querySelectorAll('.scrolling-announcement-bar-container').forEach(initScrollingBar);
  };

  /**
   * Event listeners for different loading scenarios.
   */
  // Standard page load
  document.addEventListener('DOMContentLoaded', setupAllBars);

  // Shopify Theme Editor-specific events
  if (window.Shopify && Shopify.designMode) {
    // When a section is added or reloaded
    document.addEventListener('shopify:section:load', (event) => {
      const sectionNode = event.target;
      if (sectionNode && sectionNode.querySelector('.scrolling-announcement-bar-container')) {
        const container = sectionNode.querySelector('.scrolling-announcement-bar-container');
        initScrollingBar(container);
      }
    });
    // When a setting is changed or section is selected
    document.addEventListener('shopify:section:select', (event) => {
       const sectionNode = event.target;
       if (sectionNode && sectionNode.querySelector('.scrolling-announcement-bar-container')) {
        const container = sectionNode.querySelector('.scrolling-announcement-bar-container');
        initScrollingBar(container);
      }
    });
  }

})();

  } catch(e) { console.error(e); }
})();
})();
